import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesUnsignedSalesOrdersChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.numUnsignedSalesOrdersFields",
		title: "Unsigned Sales Orders",
		yAxisLabel: "Missing Signatures (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.numUnsignedSalesOrdersFields,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.numUnsignedSalesOrdersFields );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};

